/*@ngInject*/
const FormSummaryGridUtil = function (xmlUtil) {

    this.processFormSummaryGridItems = function (formSummaryGridItems) {
        return _.map(formSummaryGridItems, function (formSummaryGridItem) {
            if (formSummaryGridItem.hasOwnProperty('name')) {
                formSummaryGridItem.name = JSON.parse(formSummaryGridItem.name);

                _.map(formSummaryGridItem.name, function (formProperty) {
                    if (formProperty.validatorProperty) {
                        formProperty.validatorProperty = xmlUtil.parseString(formProperty.validatorProperty);
                    }

                    return formProperty;
                });

                return formSummaryGridItem;
            }
        });
    }
};

angular.module('umCore')
    .service('formSummaryGridUtil', FormSummaryGridUtil);
